import { useEffect, useState } from "react";
import { useAuth } from "@/lib/hooks/use-auth";
import { api } from "@/lib/api";

export function useMentor() {
  const { user, loading: authLoading } = useAuth();
  const [isMentor, setIsMentor] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      if (authLoading) return;
      if (!user) {
        setIsMentor(false);
        setLoading(false);
        return;
      }

      try {
        const data = await api<{ is_mentor: boolean }>(`/users/${user.id}`);
        setIsMentor(Boolean(data?.is_mentor));
      } catch (err) {
        console.error("Error checking mentor status:", err);
        setIsMentor(false);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [user, authLoading]);

  return { isMentor, loading };
}
